import { makeStyles } from '@material-ui/core';

const border = '2px solid';
const borderRadius = '0px';

export const useButtonStyles = makeStyles((theme) => ({
  root: {
    textTransform: 'none',
    border: '2px solid',
  },
  outlined: {
    border: border,
    '&:hover': {
      border: border,
      color: theme.palette.secondary.main,
    },
    borderRadius: borderRadius,
    paddingBottom: '8px',
  },
  contained: {
    borderRadius: borderRadius,
    border: '2px solid',
  },
  disabled: {
    borderRadius: borderRadius,
  },
  containedPrimary: {
    borderColor: theme.palette.primary.main,
    color: '#FFF',
  },
  containedSecondary: {
    borderColor: theme.palette.secondary.main,
    color: '#FFF',
  },
}));
